import { useState } from "react";
import { GroupedCostsService } from "../../application/services/groupedCostsService";

const costService = new GroupedCostsService();

export const useGroupedCost = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [costsByService, setCostsByService] = useState([]);
  const [costsByMeter, setCostsByMeter] = useState([]);
  const [costsByServiceName, setCostsByServiceName] = useState(null);

  const getTotalCostsByService = async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await costService.getTotalCostsByService(year, month);
      if (result.success) {
        setCostsByService(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getTotalCostsByMeter = async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await costService.getTotalCostsByMeter(year, month);
      if (result.success) {
        setCostsByMeter(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getSharedCostsByService = async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await costService.getSharedCostsByService(year, month);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getCostsByServiceName = async (startDate, endDate, serviceName) => {
    setLoading(true);
    setError(null);
    try {
      const result = await costService.getCostsByServiceName(startDate, endDate, serviceName);
      if (result.success) {
        setCostsByServiceName(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getTotalCostsByService,
    getTotalCostsByMeter,
    getSharedCostsByService,
    getCostsByServiceName,
    costsByService,
    costsByMeter,
    costsByServiceName,
    loading,
    error,
  };
};